var React = require('react');

function IconCrossBoldInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m12.937 10.991 8.651-8.651a1.375 1.375 0 1 0 -1.945-1.946l-8.653 8.652-8.65-8.652a1.375 1.375 0 1 0 -1.946 1.946l8.652 8.651-8.652 8.652a1.375 1.375 0 1 0 1.946 1.945l8.651-8.652 8.652 8.652a1.372 1.372 0 0 0 1.945 0 1.375 1.375 0 0 0 0-1.946l-8.651-8.65z"}));
}

IconCrossBoldInline.defaultProps = {"height":"22","viewBox":"0 0 22 22","width":"22"};

module.exports = IconCrossBoldInline;

IconCrossBoldInline.default = IconCrossBoldInline;
